export default "__VITE_ASSET__BUhJx2ae__"